import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRegistryList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/registryList" */ './RegistryList'), 'RegistryList');
